export const sectionIds = {
  description: "description",
  cohorts: "cohorts",
  sharing: "sharing",
  facts: "facts",
} as const;

export const sectionTitleMap: Record<string, string> = {
  [sectionIds.description]: "課程介紹",
  [sectionIds.cohorts]: "過往屆別",
  [sectionIds.sharing]: "分享",
  [sectionIds.facts]: "課程資料",
};

export const repeatedCohortCardCount = 8;
export const fallbackHeroImage = "landingBackground/landingBackground.jpg";
export const heroOffsetTop = 96;
